import styled, { css } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

// Re-export shared components for backward compatibility
export {
  PageContainer,
  ContentArea,
  SectionHeader,
  FooterWrapper,
  FooterPattern,
  Footer,
  PageNumber,
} from '../CardisPropertyCharacteristics/CardisPropertyCharacteristics.styles'

const printStyles = css`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Title = styled.h1`
  font-family: ${cardisTheme.fonts.body};
  font-size: 16px;
  font-weight: 500;
  color: ${cardisTheme.colors.secondary};
  margin: 0 0 20px 0;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media print {
    ${printStyles}
  }
`

export const IntroText = styled.p`
  font-family: ${cardisTheme.fonts.body};
  font-size: 12px;
  font-weight: 400;
  color: ${cardisTheme.colors.textDark};
  margin: 0 0 20px 0;
  line-height: 1.6;

  strong {
    font-weight: 600;
  }

  @media print {
    font-size: 12px !important;
    color: ${cardisTheme.colors.textDark} !important;
    margin: 0 0 20px 0 !important;
    line-height: 1.6 !important;
    ${printStyles}
  }
`

export const PriceRangeBanner = styled.div`
  background-color: ${cardisTheme.colors.primary};
  padding: 16px 32px;
  margin-left: -${cardisTheme.spacing.pageMargin};
  margin-right: -${cardisTheme.spacing.pageMargin};
  margin-bottom: 24px;
  text-align: center;

  @media print {
    ${printStyles}
  }
`

export const PriceRangeText = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 32px;
  font-weight: 600;
  color: ${cardisTheme.colors.white};
  letter-spacing: 0.5px;

  @media print {
    ${printStyles}
  }
`

export const PriceRangeTextItalic = styled.span`
  font-style: italic;
  font-size: 18px;
  font-weight: 400;

  @media print {
    ${printStyles}
  }
`

export const BrokerCommentSection = styled.div`
  margin-bottom: 24px;
`

export const SectionTitle = styled.h2`
  font-family: ${cardisTheme.fonts.body};
  font-size: 18px;
  font-weight: 600;
  color: ${cardisTheme.colors.primary};
  margin: 0 0 16px 0;

  @media print {
    font-size: 18px !important;
    font-weight: 600 !important;
    color: ${cardisTheme.colors.primary} !important;
    margin: 0 0 16px 0 !important;
    ${printStyles}
  }
`

export const CommentBox = styled.div`
  display: flex;
  gap: 32px;
  align-items: stretch;

  @media print {
    display: flex !important;
    gap: 32px !important;
  }
`

export const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const CommentText = styled.p`
  font-family: ${cardisTheme.fonts.body};
  font-size: 14px;
  font-weight: 400;
  color: ${cardisTheme.colors.textDark};
  margin: 0 0 24px 0;
  line-height: 1.3;
  text-align: justify;

  strong {
    font-weight: 700;
  }

  @media print {
    ${printStyles}
  }
`

export const BrokerInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: auto;
`

export const BrokerPhoto = styled.img`
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;

  @media print {
    width: 140px !important;
    height: 140px !important;
    border-radius: 50% !important;
    ${printStyles}
  }
`

export const BrokerDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const BrokerName = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 18px;
  font-weight: 700;
  color: ${cardisTheme.colors.primary};

  @media print {
    ${printStyles}
  }
`

export const BrokerTitle = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 11px;
  font-weight: 400;
  color: ${cardisTheme.colors.textGray};

  @media print {
    ${printStyles}
  }
`

export const BrokerEmail = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 11px;
  font-weight: 400;
  color: ${cardisTheme.colors.textDark};

  @media print {
    ${printStyles}
  }
`

export const BrokerPhone = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 14px;
  font-weight: 700;
  color: ${cardisTheme.colors.textDark};

  @media print {
    ${printStyles}
  }
`

export const StatisticsBox = styled.div`
  width: 340px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f5f3ef;
  border-radius: 8px;
  padding: 32px 24px;
  text-align: center;

  @media print {
    ${printStyles}
  }
`

export const StatisticsHeader = styled.p`
  font-family: ${cardisTheme.fonts.body};
  font-size: 16px;
  font-weight: 400;
  color: ${cardisTheme.colors.primary};
  margin: 0 0 24px 0;
  line-height: 1.3;

  @media print {
    ${printStyles}
  }
`

export const StatisticsHighlight = styled.p`
  font-family: ${cardisTheme.fonts.body};
  font-size: 18px;
  font-weight: 700;
  color: ${cardisTheme.colors.primary};
  margin: 0;
  line-height: 1.3;

  @media print {
    ${printStyles}
  }
`

// Legacy - keeping for backwards compatibility
export const RightColumn = StatisticsBox

export const StatisticsText = styled.p`
  font-family: ${cardisTheme.fonts.body};
  font-size: 11px;
  font-weight: 400;
  color: ${cardisTheme.colors.textDark};
  margin: 0;
  line-height: 1.6;

  strong {
    font-weight: 700;
    color: ${cardisTheme.colors.primary};
  }

  @media print {
    font-size: 11px !important;
    color: ${cardisTheme.colors.textDark} !important;
    line-height: 1.6 !important;
    ${printStyles}
  }
`

export const TeamSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 12px;
`

export const TeamTitle = styled.h2`
  font-family: ${cardisTheme.fonts.body};
  font-size: 16px;
  font-weight: 400;
  color: ${cardisTheme.colors.primary};
  margin: 0 0 16px 0;
  letter-spacing: 0.5px;

  @media print {
    ${printStyles}
  }
`

export const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-bottom: 16px;
  padding-top: 8px;

  @media print {
  }
`

export const TeamMemberCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const TeamMemberPhoto = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 6px;

  @media print {
    width: 70px !important;
    height: 70px !important;
    border-radius: 50% !important;
    margin-bottom: 6px !important;
    ${printStyles}
  }
`

export const TeamMemberName = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 9px;
  font-weight: 600;
  color: ${cardisTheme.colors.primary};
  line-height: 1.2;
  text-align: left;
  width: 100%;

  @media print {
    ${printStyles}
  }
`

export const TeamMemberTitle = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 8px;
  font-weight: 400;
  color: ${cardisTheme.colors.textGray};
  line-height: 1.2;
  text-align: left;
  width: 100%;
  padding-top: 4px;

  @media print {
    ${printStyles}
  }
`

export const TeamLogoRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const CardisLogo = styled.img`
  width: 120px;
  height: auto;
  object-fit: contain;

  @media print {
    width: 120px !important;
    height: auto !important;
    ${printStyles}
  }
`
